var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.356934,
    y: 0.70105,
    width: 44.6566,
    height: 44.6876,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_31_124",
    transform: "matrix(0.0104239 0 0 0.0104167 -0.000347202 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_31_124",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACDklEQVR4nO2bTU7DMBBGP1iwcYW4DOcjR+ACRdyAI3TBjstwBKNILLroX5zYM515T/Ky6cz37LR1XAkAAAAAAAAAAAAAwD2VoTkDBMh2MiBACEh9OzLDuvHqZCBACPAxIzpzNysgKtVbv+4Kytavu4Ky9euuoGz9uisoW7/uCsrWr7uCsvXrrqBs/W5d0IN8E1rAJOlD0qP6USR9SXptfH1YAdPRa3tJmMM//L/Hb6OEkAKmE6/fWsJx+HWFhHACpgvX2ErCqfBbJYQS8CTp+8I15rFfKWF3w3u8ZxVwbXauXQk9rh1OQK+geokNKWDrwHquqrACtgquZ/jhBawNsHf4KQS0Bjki/DQClgY6KvxUAm79Dv854LdEWgG6cXaPmPlpBayR0GNTL6WAFgm9dlTTClgioeczBQQIASYzonALsluShQ/h8/A1VHE/hHf8ELMTUNiKsBNQ2IyzE1DYjrYTUHggYyeg8EjSTkDhobydgMKxFDsBOycHs/YLTmWH2ox7kfQzYFfz2ip7W3CtUAIuSRhxOHdp+CEFnJIw4nh6S/hhBRxLGPEHjUNj+KEFzDx3Dv/4VHYroQXcA+76dVdQtn7dFZStX3cFZevXXUHZ+nVXULZ+3RWUrV93BWXr111B2fo9V1C2YYZ149XJQIAQYD4LKyvAPojKLcg+jGowAAAAAAAAAAAAAADkmD9tUm7R6QBONwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0756f1c8af8331e0b01ba33e9eef96c0.svg";
export { ForwardRef as ReactComponent };